import React from "react";

import { Button } from "reactstrap";

import NavbarPrimary from "../sections/NavbarPrimary.js";
import Footer from "../sections/Footer.js";
import AccordionPrivacy from "../accordions/AccordionPrivacy.js";

function ContactUs() {
  React.useEffect(() => {
    document.body.classList.add("index");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    let href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    if (
      window.location.href.lastIndexOf("#") > 0 &&
      document.getElementById(href)
    ) {
      document.getElementById(href).scrollIntoView();
    }
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      <NavbarPrimary />
      <Button
          className="btn-icon-only back-to-top text-lowercase text-default show"
          color="info"
          name="button"
          type="button"
          onClick={() => {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
          }}
        >
            &alpha;
        </Button>
      <AccordionPrivacy />
      <Footer />
    </>
  );
}

export default ContactUs;
